import { ProductTierSku } from '@vendia/management-api-types'
import { useParams } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { LinkItem, SideNavLinkItem } from 'src/components/navigation/side-nav-link-item'
import { useGetOrg } from 'src/utils/hooks/use-get-org'
import { useIsEnterpriseOrgMember } from 'src/utils/hooks/use-is-org-member'

export default function UniSettingsNav({ uniPending = false }: { uniPending?: boolean }) {
  const { id: uniName, node: nodeName } = useParams()
  const getOrg = useGetOrg()
  const { data: isEnterprise } = useIsEnterpriseOrgMember()
  const productTierSku = getOrg?.data?.getOrganization?.productTier?.sku

  // Check if user is on free tier, individual or pro account
  const isFreeTierOrIndividual =
    productTierSku === ProductTierSku.Individual || productTierSku === ProductTierSku.Pro || (!isEnterprise && !productTierSku)

  let links: LinkItem[] = [
    {
      label: 'Back',
      path: '../entities',
      iconName: 'lucide-arrow-left',
      isBack: true,
    },
    {
      label: 'Resources',
      path: 'resources',
      isDisabled: uniPending,
    },
    {
      label: 'Authentication',
      path: 'auth-settings',
      isDisabled: uniPending,
    },
    {
      label: 'Success notifications',
      path: 'success-notifications',
      isDisabled: uniPending,
    },
    {
      label: 'Error notifications',
      path: 'error-notifications',
      isDisabled: uniPending,
    },
    {
      label: 'Smart contracts',
      path: 'smart-contracts',
      isDisabled: uniPending,
    },
    {
      label: 'Schema',
      path: 'schema',
    },
    {
      label: 'Project Settings',
      path: 'uni-settings',
    },
    {
      label: 'Danger zone',
      path: 'danger-zone',
    },
  ]

  // For free tier and individual accounts, only show Back and Danger zone
  if (isFreeTierOrIndividual) {
    links = [
      {
        label: 'Back',
        path: '../getting-started',
        iconName: 'lucide-arrow-left',
        isBack: true,
      },
      {
        label: 'Danger zone',
        path: 'danger-zone',
      },
    ]
  }

  const location = useLocation()
  const linkListItems = links?.map((link, index) => {
    const basePath = `/uni/${uniName}/${nodeName}/settings/`
    const path = `${basePath}${link.path}`
    // Normalize trailing slash and compare to find active path
    const currentPath = location.pathname.replace(/\/+$/, '')
    const currentLinkPath = path.replace(/\/+$/, '')
    link.isActive = currentPath.includes(currentLinkPath)
    link.path = path

    return <SideNavLinkItem key={`${path}-${index}`} linkItem={link} />
  })

  return (
    <div className={'max-h-[calc(100vh-76px)] w-56 overflow-y-auto border-t border-slate-200 p-4 pt-8'}>
      {linkListItems}
    </div>
  )
}
